<template>
  <el-dialog
    class="process-mind-map-dialog process-mind-map-source-dialog fishbone-form-detail-dialog po-request-detail-dialog"
    v-dialogDrag
    :visible.sync="innerVisible"
    width="96vw"
    append-to-body
    top="4vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="loadData"
    @closed="resetData">
    <div slot="title" class="fishbone-form-detail-dialog__title">
      <span>{{ $LANG('', '采购订单明细') }}</span>
    </div>
    <div class="fishbone-form-detail-dialog__body">
      <div class="po-request-detail-dialog__filters">
        <el-input
          v-model="filters.materialName"
          size="mini"
          clearable
          :placeholder="$LANG('', '物料名称')"
          :aria-label="$LANG('', '物料名称')">
        </el-input>
        <el-input
          v-model="filters.materialCode"
          size="mini"
          clearable
          :placeholder="$LANG('', '物料编码')"
          :aria-label="$LANG('', '物料编码')">
        </el-input>
        <el-select
          class="po-request-detail-dialog__status-filter"
          v-model="filters.status"
          size="mini"
          clearable
          filterable
          :placeholder="$LANG('', '状态')"
          :aria-label="$LANG('', '状态')">
          <el-option
            v-for="status in statusOptions"
            :key="status"
            :label="status"
            :value="status">
          </el-option>
        </el-select>
        <el-input
          v-model="filters.purchaseOrder"
          size="mini"
          clearable
          :placeholder="$LANG('', '采购单号')"
          :aria-label="$LANG('', '采购单号')">
        </el-input>
        <el-button class="po-request-detail-dialog__reset" size="mini" @click="resetFilters">{{ $LANG('', '重置') }}</el-button>
      </div>
      <el-table
        :data="filteredTableData"
        border
        size="small"
        ref="detailTable"
        class="custom-table-border fishbone-form-detail-dialog__table"
        v-loading="loading"
        :element-loading-text="$LANG('1959', '加载中')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 251, 255, 0.8)"
        show-summary
        :summary-method="getSummary"
        :cell-style="{ padding: '2px' }"
        :header-cell-style="headStyle"
        :row-class-name="tabRowClass"
        cell-class-name="clearPadding2"
        height="calc(88vh - 97px)"
        highlight-current-row>
        <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
        <el-table-column
          v-for="item in displayColumns"
          :key="item.key"
          :prop="item.key"
          :label="item.title"
          show-overflow-tooltip
          :align="item.align"
          :sortable="item.key === 'POSTFG' || item.key === 'WAREHOUSE_RATE' || (item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N')"
          :sort-method="item.key === 'WAREHOUSE_RATE' ? compareWarehouseRate : undefined"
          :min-width="getColumnMinWidth(item)">
          <template slot-scope="scope">
            <el-progress
              v-if="item.key === 'WAREHOUSE_RATE'"
              class="po-request-detail-dialog__progress"
              :percentage="getWarehouseRate(scope.row)"
              :text-inside="true"
              :stroke-width="16">
            </el-progress>
            <el-checkbox
              v-else-if="item.edcss === 'checkbox'"
              disabled
              true-label="Y"
              false-label="N"
              v-model="scope.row[item.key]">
            </el-checkbox>
            <span v-else-if="item.key === 'MATTYPE'" v-text="displayText(scope.row.CMATTY || scope.row[item.key])"></span>
            <el-tag v-else-if="item.key === 'POSTFG'" size="mini" effect="plain" :type="getStatusTagType(scope.row[item.key])">{{ displayText(scope.row[item.key]) }}</el-tag>
            <span v-else v-text="displayText(scope.row[item.key])"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { getTabColOrData } from '../../api/user'

export default {
  name: 'PoRequestDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    },
    orderRow: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      columns: [],
      tableData: [],
      filters: {
        materialName: '',
        materialCode: '',
        status: '',
        purchaseOrder: ''
      },
      statusOptions: ['未开始', '进行中', '已完成', '异常', '加急']
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    visibleColumns: function () {
      var hiddenKeys = ['SEL', 'REQQTY', 'BOMUNITNM', 'MATTYNM', 'POUNITNM', 'UNITNM', 'QTY', 'RMK', 'ADDUSER', 'ADDDTTM']
      return this.columns.filter(function (item) {
        return item.thide === 'N' && hiddenKeys.indexOf(item.key) === -1
      })
    },
    displayColumns: function () {
      var supplierColumn = this.visibleColumns.find(function (item) { return item.key === 'SUPNM' }) || {
        title: '供应商',
        key: 'SUPNM',
        align: 'left',
        width: 180,
        edcss: 'input',
        sortable: 'Y'
      }
      return this.visibleColumns.reduce(function (columns, item) {
        if (item.key === 'SUPNM') return columns
        columns.push(item)
        if (item.key === 'STAFF') {
          columns.push({
            title: '入库比例',
            key: 'WAREHOUSE_RATE',
            align: 'center',
            width: 130,
            edcss: 'progress',
            sortable: 'Y'
          })
        }
        if (item.key === 'LOCKQTY') columns.push(supplierColumn)
        return columns
      }, [])
    },
    filteredTableData: function () {
      var materialName = String(this.filters.materialName || '').trim().toLowerCase()
      var materialCode = String(this.filters.materialCode || '').trim().toLowerCase()
      var status = String(this.filters.status || '').trim()
      var purchaseOrder = String(this.filters.purchaseOrder || '').trim().toLowerCase()
      return this.tableData.filter(function (row) {
        var rowMaterialName = String(row.MATNM || '').toLowerCase()
        var rowMaterialCode = String(row.MATNO || '').toLowerCase()
        var rowStatus = String(row.POSTFG || '').trim()
        var rowPurchaseOrder = String(row.PONO || '').toLowerCase()
        return (!materialName || rowMaterialName.indexOf(materialName) !== -1) &&
          (!materialCode || rowMaterialCode.indexOf(materialCode) !== -1) &&
          (!status || rowStatus === status) &&
          (!purchaseOrder || rowPurchaseOrder.indexOf(purchaseOrder) !== -1)
      })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.resetFilters()
    },
    resetFilters: function () {
      this.filters.materialName = ''
      this.filters.materialCode = ''
      this.filters.status = ''
      this.filters.purchaseOrder = ''
    },
    loadData: function () {
      this.loading = true
      this.loadColumns().then(function (columns) {
        this.columns = columns
        return this.loadRows().catch(function () {
          return []
        })
      }.bind(this)).then(function (rows) {
        this.tableData = rows || []
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    loadColumns: function () {
      return getTabColOrData(this.tableUrl, 'v_sys_form_fld', 'idseq', '16572', 'lstseq', '2097', '', '', ' order by sortby,lstseq').then(function (res) {
        var list = (res && res.result) || []
        return list.map(function (item) {
          return {
            title: this.$translate.getColTitle(item, this.$store.state.lang),
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            edcss: item.EDCSS,
            sortable: item.SORTABLE
          }
        }.bind(this))
      }.bind(this))
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(this.tableUrl, payload.p_table, payload.p_key, payload.p_value, payload.p_key2, payload.p_value2, '', '', '').then(function (res) {
        return (res && res.result) || []
      })
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getOrderData: function () {
      return this.orderRow || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var orderRow = this.getOrderData()
      var params = {
        ORDNO: row.ORDNO || row.IDNO || row.REFIDNO || orderRow.ORDNO || orderRow.IDNO || orderRow.REFIDNO,
        ORDSEQ: row.ORD_IDSEQ || row.ORDSEQ || orderRow.IDSEQ || orderRow.ORD_IDSEQ || orderRow.ORDSEQ,
        CORPID: row.CORPID || orderRow.CORPID || this.$cookies.get('v_corpid')
      }
      var missing = []
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: 'ordseq',
        p_value: params.ORDSEQ,
        p_key2: 'corpid',
        p_value2: params.CORPID,
        p_table: 'V_po_reqdtl'
      }
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    getWarehouseRate: function (row) {
      row = row || {}
      var purchaseQuantity = Number(String(row.POQTY === undefined || row.POQTY === null ? '' : row.POQTY).replace(/,/g, ''))
      var receivedQuantity = Number(String(row.POINQTY === undefined || row.POINQTY === null ? '' : row.POINQTY).replace(/,/g, ''))
      if (!isFinite(purchaseQuantity) || purchaseQuantity <= 0 || !isFinite(receivedQuantity) || receivedQuantity <= 0) return 0
      return Math.min(100, Math.round(receivedQuantity / purchaseQuantity * 100))
    },
    compareWarehouseRate: function (left, right) {
      return this.getWarehouseRate(left) - this.getWarehouseRate(right)
    },
    getColumnMinWidth: function (item) {
      item = item || {}
      var configuredWidth = parseInt(item.width, 10) || 0
      var title = String(item.title || '')
      var isSortable = item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'
      var titleWidth = Array.from(title).reduce(function (total, char) {
        return total + (/[\u4e00-\u9fff]/.test(char) ? 14 : 8)
      }, 0)
      var headerWidth = titleWidth + (isSortable ? 22 : 0) + 24
      if (item.key === 'POSTFG') headerWidth = Math.max(headerWidth, 88)
      return Math.max(configuredWidth, headerWidth)
    },
    getStatusTagType: function (status) {
      if (status === '进行中') return 'primary'
      if (status === '已完成') return 'success'
      if (status === '异常') return 'warning'
      if (status === '加急') return 'danger'
      return 'info'
    },
    tabRowClass: function (params) {
      var row = params.row || {}
      row.index = params.rowIndex
      if (row.POSTFG === '未开始') return 'row-gray'
      if (row.POSTFG === '进行中') return 'row-blue'
      if (row.POSTFG === '已完成') return 'row-green'
      if (row.POSTFG === '异常') return 'row-yellow'
      if (row.POSTFG === '加急') return 'row-red'
      return 'row-gray'
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (column.property === 'AMT' || column.property === 'QTY') return 'color:red'
    },
    getSummary: function (param) {
      var sums = []
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        if (column.property === 'QTY' || column.property === 'REQQTY' || column.property === 'LOCKQTY' || column.property === 'AMT' || column.property === 'POQTY' || column.property === 'POINQTY') {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr)
            if (!isNaN(value)) return Number(Number(prev) + Number(curr)).toFixed(2)
            return prev
          }, '')
        }
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped>
.fishbone-form-detail-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.fishbone-form-detail-dialog__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.po-request-detail-dialog__filters {
  flex: none;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.po-request-detail-dialog__filters .el-input,
.po-request-detail-dialog__filters .el-select {
  width: 150px;
}
.po-request-detail-dialog__progress {
  width: 110px;
  margin: 0 auto;
}
.fishbone-form-detail-dialog__table {
  flex: 1;
  min-height: 0;
  width: 100%;
}
</style>

<style lang="less">
.process-mind-map-dialog.po-request-detail-dialog {
  .el-dialog {
    display: flex !important;
    flex-direction: column !important;
  }
  .el-dialog__header {
    flex: none !important;
  }
  .el-dialog__body {
    flex: 1 !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }
  .po-request-detail-dialog__filters .el-input--mini .el-input__inner {
    height: 28px !important;
    min-height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
  }
  .po-request-detail-dialog__filters .el-input--mini .el-input__icon {
    height: 28px;
    line-height: 28px;
  }
  .po-request-detail-dialog__filters .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
    height: 100%;
    vertical-align: top;
  }
  .po-request-detail-dialog__status-filter,
  .po-request-detail-dialog__status-filter .el-input {
    height: 28px;
  }
  .po-request-detail-dialog__status-filter .el-input__suffix,
  .po-request-detail-dialog__status-filter .el-select__caret {
    height: 28px !important;
    line-height: 28px !important;
  }
  .po-request-detail-dialog__reset {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
    line-height: 28px !important;
  }
  .el-table th > .cell {
    white-space: nowrap;
    word-break: keep-all;
  }
}

.process-mind-map-dialog.fishbone-form-detail-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
  .el-table .row-red { color: red; }
  .el-table .row-gray { color: #909399; }
  .el-table .row-blue { color: blue; }
  .el-table .row-green { color: green; }
  .el-table .row-yellow { color: rgb(255, 165, 0); }
}
</style>
